import SplitButtonBase, {
  SplitButtonOptionProps,
  SplitButtonProps,
} from './SplitButton';

export type { SplitButtonOptionProps, SplitButtonProps };
export const SplitButton = SplitButtonBase;
